import { useMemo, useState } from "react";
import { ServiceObjectUpcomingRevisionsTableQuery } from "../../../serviceObjects/models";
import { CPUpcomingServiceObjectRevision } from "../../../../api/models/unified";
import { Column } from "react-data-grid";
import { renderDate } from "../../../../helpers/dayjsHeleprs";
import { useCustomTranslation } from "../../../../helpers/translateHelpers";
import { useGetUpcomingServiceObjectRevisionsQuery } from "../../../serviceObjects/queries";
import { Table } from "../../../../components";
import { getTablePageCount } from "../../../../helpers/tableHelpers";
import { useNavigate } from "../../../../helpers/navigationHelpers";

const defaultTableQuery: ServiceObjectUpcomingRevisionsTableQuery = {
  page: 1,
  pageSize: 10,
};

const HomeServiceObjectsUpcomingRevisionsTable = () => {
  const { tServiceObject } = useCustomTranslation();

  const [queryParams, setQueryParams] =
    useState<ServiceObjectUpcomingRevisionsTableQuery>(defaultTableQuery);

  const query = useGetUpcomingServiceObjectRevisionsQuery(queryParams);
  const navigate = useNavigate();

  const columns = useMemo<Column<CPUpcomingServiceObjectRevision>[]>(
    () => [
      {
        name: tServiceObject("name"),
        key: "serviceObjectName",
        sortable: true,
      },
      {
        name: tServiceObject("category"),
        key: "categoryName",
        sortable: true,
      },
      {
        name: tServiceObject("identification_number"),
        key: "identificationNumber",
        sortable: true,
      },
      {
        name: tServiceObject("revision_category_name"),
        key: "revisionCategoryName",
        sortable: true,
      },
      {
        name: tServiceObject("next_revision_date"),
        key: "nextRevision",
        renderCell: ({ row }) => renderDate(row.nextRevision),
        sortable: true,
      },
    ],
    [tServiceObject],
  );

  return (
    <Table
      columns={columns}
      data={query.data?.data ?? []}
      loading={query.isLoading}
      queryParams={queryParams}
      onTableQueryChange={setQueryParams}
      pageCount={getTablePageCount(
        query.data?.total ?? 1,
        queryParams.pageSize,
      )}
      onRowClick={(item) =>
        navigate.goTo(`serviceObjects/${item.serviceObjectId}`)
      }
    />
  );
};

export default HomeServiceObjectsUpcomingRevisionsTable;
